import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const WarningIcon = ({ label = 'Warning', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M150 39.7 22.1 266h255.8z" style="fill:#ff9015"/><path d="M150 39.7 277.9 266H22.1L150 39.7m0-10a10 10 0 0 0-8.7 5L13.4 261.1a10 10 0 0 0 8.7 14.9h255.8a10 10 0 0 0 8.7-14.9L158.7 34.7a10 10 0 0 0-8.7-5z" style="fill:#1d1d1b"/><path d="M167.6 227.8a17.6 17.6 0 1 1-17.3-17.5 17.5 17.5 0 0 1 17.3 17.5zm-1.7-49.9c0 7.6-.2 9.5-2.2 13.2a15.7 15.7 0 0 1-13.6 8c-5.8 0-11.4-3.3-13.8-8s-2.2-5.4-2.2-13.2v-62.6c0-7.6.2-9.5 2.2-13.2s8-8 13.8-8 11.2 3.2 13.6 8 2.2 5.4 2.2 13.2zm-100 46.6a5 5 0 0 1-4.4-7.4l20.4-37.3a5 5 0 0 1 8.8 4.8l-20.4 37.3a5 5 0 0 1-4.4 2.6zm-12.8 23.3a5.3 5.3 0 0 1-2.4-.6 5.1 5.1 0 0 1-2-6.8l5.7-10.3a5 5 0 0 1 6.8-2 4.9 4.9 0 0 1 1.9 6.8l-5.6 10.3a5.1 5.1 0 0 1-4.4 2.6zM253.5 259h-15.3a5 5 0 0 1 0-10h15.3a5 5 0 0 1 0 10z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

WarningIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { WarningIcon }
